import { render, staticRenderFns } from "./r-plinko-bucket-config-table.vue?vue&type=template&id=1669cc2c"
import script from "./r-plinko-bucket-config-table.vue?vue&type=script&lang=js"
export * from "./r-plinko-bucket-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1669cc2c')) {
      api.createRecord('1669cc2c', component.options)
    } else {
      api.reload('1669cc2c', component.options)
    }
    module.hot.accept("./r-plinko-bucket-config-table.vue?vue&type=template&id=1669cc2c", function () {
      api.rerender('1669cc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-bucket-config-table.vue"
export default component.exports